import { DetailsPageTopControlsView } from "../../common/panels/misc/DetailsPageTopControlsView/DetailsPageTopControlsView";
import { EntityDeleteButton } from "../../Entities/GenericComponents/common/GenericEntityDetailPage";
import { EntityDetailProps, EntityDetailTableProps } from "../../common/entity/EntityInterfaces";
import { Table } from "../../common/panels/Detail/DetailTable";
import { toUppercase } from "../../common/helperfunctions/stringFunctions";
import { NotAvailable, NotSet } from "../../common/misc/UIconstants";
import { GetProjects } from "../../common/misc/EntityRenders/EntityRenderer";
import { EntityEditButton } from "../../common/entity/entityComponents/EntityEditButton";
import { EntityCloneButton } from "../../common/entity/entityComponents/EntityCloneButton";
import { EntityComplianceDropdown } from "../../common/entity/entityComponents/EntityComplianceDropdown";
import { GenericEntityExportButton } from "../../Entities/GenericComponents/common/GenericEntityExportButton";

interface LabNotebooksDetailTableProps extends EntityDetailTableProps<"notebooks"> {}

export const LabNotebooksDetailTable = ({
  entity,
  entityConstants,
  fieldLabels,
  entityTypeId,
}: LabNotebooksDetailTableProps) => {
  return (
    <Table noPadding>
      <Table.Head>{toUppercase(entityConstants.entitySingular)} details</Table.Head>
      <Table.Body>
        <Table.Body.RowContent
          title={fieldLabels.name}
          content={
            <div className="container_label">
              <div className="container_label_name" style={{ fontWeight: 600 }}>
                {entity.name ?? NotSet}
              </div>
              <div className="container_label_id">
                <span style={{ whiteSpace: "nowrap" }}>
                  {toUppercase(entityConstants.entitySingular)}-ID: {entity.id ?? NotAvailable}
                </span>
              </div>
            </div>
          }
        />

        <Table.Body.RowContent
          title={fieldLabels.description}
          content={
            entity.description ? (
              <div className={"container_notes"}>
                <textarea rows={2} className={"container_textarea"} value={entity.description} disabled={true} />
              </div>
            ) : (
              NotSet
            )
          }
        />

        <Table.Body.RowContent title={fieldLabels.projects} content={<GetProjects projects={entity.projects} />} />
      </Table.Body>
    </Table>
  );
};

export const LabNotebooksDetail = ({
  permissions,
  routes,
  entity,
  entityApi,
  entityConstants,
  fieldLabels,
  entityTypeId,
}: EntityDetailProps<"notebooks">) => {
  return (
    <div className="flex" style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <div
        className="flex col-nowrap"
        style={{ padding: "15px 15px 10px 15px", width: "100%", backgroundColor: "var(--white)" }}
      >
        <DetailsPageTopControlsView
          entityTypeId={entityTypeId}
          entity={entity}
          entityConstants={entityConstants}
          controls={
            <>
              <EntityEditButton
                entity={entity}
                entityConstants={entityConstants}
                permissions={permissions}
                routes={routes}
              />
            </>
          }
          controlsDropdown={
            <>
              <li>
                <EntityCloneButton
                  entity={entity}
                  entityConstants={entityConstants}
                  routes={routes}
                  permissions={permissions}
                />
              </li>
              <li>
                <GenericEntityExportButton entity={entity} entityTypeId={entityTypeId} />
              </li>
              <EntityComplianceDropdown entity={entity} entityTypeId={entityTypeId} showSignButton />
              <li className="divider" />
              <li>
                <EntityDeleteButton entityTypeId={entityTypeId} entity={entity} />
              </li>
            </>
          }
        />

        <LabNotebooksDetailTable
          entity={entity}
          entityConstants={entityConstants}
          fieldLabels={fieldLabels}
          entityTypeId={entityTypeId}
        />
      </div>
    </div>
  );
};
